const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ]

import "es6-promise/auto";
import "fetch-polyfill";
import 'particles.js'

export class PARTICLE {
  constructor( option ){

    // オプションを拡張
    this.opt = Object.assign({
      query: '[data-plugin="particle"], .mainImg .mainImgInner'
    }, option);

    // 要素の初期化
    w.load['loadHtml'].then( () => this.init() );
    this.load = Promise.all([
      fetch('/asset/json/particlejs-conf.json').then( res => res.json() ),
      fetch('/asset/json/particlejs-conf-sp.json').then( res => res.json() )
    ]);

  }

  async init () {
    const elms = d.querySelectorAll( this.opt.query );
    const conf = await this.load; // particlejs-conf.jsonの内容をfetchで取得
    // 選択したDOMにHTML挿入とParticlesJSの実行
    if ( elms.length > 0 ) elms.forEach( ( e, i ) => this.applyParticle( e, i, conf ) );

  }

  applyParticle ( elm, i, conf ){
    const dom_id = 'particle-js-dom-' + i.toString().padStart(2, 0);
    elm.insertAdjacentHTML('beforeend', `<div id="${dom_id}" class="particle-stg" />`);
    particlesJS( dom_id, (mq.matches)? conf[1]: conf[0] );
  }
}